import { render, staticRenderFns } from "./BalancePaySetting.vue?vue&type=template&id=740a5a9f&scoped=true"
import script from "./BalancePaySetting.vue?vue&type=script&lang=js"
export * from "./BalancePaySetting.vue?vue&type=script&lang=js"
import style0 from "./BalancePaySetting.vue?vue&type=style&index=0&id=740a5a9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a5a9f",
  null
  
)

export default component.exports